import React, { ReactNode } from 'react'
import { useCountries } from 'hooks/use-countries'
import Avatar from 'components/profile/Avatar'
import styles from './styles/search-results-table-desktop.module.scss'
import { Flag } from 'components/generic/Country'
import { Player } from 'types/global'
import { formatAddress, getAgeReference, getProfileUrl } from 'utils'
import classNames from 'classnames'
import RatingWithConfidenceTick from 'components/generic/RatingWithConfidenceTick'

export interface SearchResultProps {
  player: Player
  withLink?: boolean
  children?: ReactNode
  className?: string
}

const SearchResult: React.FC<SearchResultProps> = ({
  player,
  children,
  withLink = false,
  className = '',
}) => {
  const {
    id,
    fullName,
    gender,
    age,
    birthYear,
    countryCode,
    avatar,
    wtnDoubles,
    wtnSingles,
    wtnConfidenceSingles,
    wtnConfidenceDoubles,
    location,
  } = player || {}
  const { getCountryName } = useCountries()
  const ageReference = getAgeReference(age, birthYear)
  const formattedLocation = location?.main && formatAddress(location.main)
  const info = formattedLocation ? `${gender}, ${formattedLocation}` : gender

  return (
    <tr key={id} className={classNames(styles.searchResult, className)}>
      <td className={styles.player}>
        <div className={styles.avatarContainer} aria-hidden>
          <Avatar url={avatar} />
        </div>
        <p className={styles.playerDetails}>
          {withLink ? (
            <a href={getProfileUrl(id)} className={styles.playerName}>
              {fullName}{' '}
            </a>
          ) : (
            <span className={styles.playerName}>{fullName}</span>
          )}

          <span className={styles.playerInfo}>{info}</span>
        </p>
      </td>
      <td className={styles.country}>
        <Flag alpha3={countryCode} />
        <span>{getCountryName(countryCode)}</span>
      </td>
      <td>{ageReference}</td>
      <td>
        <RatingWithConfidenceTick rating={wtnSingles} confidence={wtnConfidenceSingles} />
      </td>
      <td>
        <RatingWithConfidenceTick rating={wtnDoubles} confidence={wtnConfidenceDoubles} />
      </td>
      {children}
    </tr>
  )
}

export default SearchResult
